import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function AdminAddCourse() {
  const [formData, setFormData] = useState({
    courseName: '',
    courseSummary: '',
    coursePeriod: '',
    fees: ''
  });
  const [courseImage, setCourseImage] = useState(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    // Clear error on change
    setErrors((prev) => ({ ...prev, [id]: '' }));
  };
  const handleImageChange = (e) => {
    setCourseImage(e.target.files[0]);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageType('');
    setErrors({});
    let valid = true;
    if (!formData.courseName) {
      setErrors((prev) => ({ ...prev, courseName: 'Course Name is required' }));
      valid = false;
    }
    if (!formData.courseSummary) {
      setErrors((prev) => ({ ...prev, courseSummary: 'Course Summary is required' }));
      valid = false;
    }
    if (!formData.coursePeriod) {
      setErrors((prev) => ({ ...prev, coursePeriod: 'Course Period is required' }));
      valid = false;
    } else if (formData.coursePeriod.length > 20) {
      setErrors((prev) => ({ ...prev, coursePeriod: 'Too much information in Duration Field. Make it short!' }));
      valid = false;
    }
    if (!formData.fees || isNaN(parseFloat(formData.fees))) {
      setErrors((prev) => ({ ...prev, fees: 'Fees must be a valid number' }));
      valid = false;
    }
    if (!courseImage) {
      setErrors((prev) => ({ ...prev, courseImage: 'Course Image is required' }));
      valid = false;
    }
    if (!valid) {
      setLoading(false);
      return;
    }
    if (!apiUrl) {
      setMessage('API URL is not defined. Please check your environment configuration.');
      setMessageType('error');
      setLoading(false);
      return;
    }
    const data = new FormData();
    data.append('courseName', formData.courseName);
    data.append('courseSummary', formData.courseSummary);
    data.append('coursePeriod', formData.coursePeriod);
    data.append('fees', formData.fees);
    if (courseImage) {
      data.append('courseImage', courseImage);
    }
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to add a course.');
        setMessageType('error');
        setLoading(false);
        return;
      }
      const response = await axios.post(`${apiUrl}/api/admin/courses`, data, {
        headers: {
          Authorization: `Bearer ${sessionData.token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.data.success) {
        setMessage('Course added successfully!');
        setMessageType('success');
        setFormData({ courseName: '', courseSummary: '', coursePeriod: '', fees: '' });
        setCourseImage(null);
        // Optionally redirect to dashboard
        // setTimeout(() => navigate('/admin-dashboard'), 2000);
      } else {
        setMessage(response.data.message || 'Failed to add course.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error adding course. Please try again.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        {/* Top nav bar */}
        <TopNavBar />
       
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            {/* Breadcrumb Start */}
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link
                    to="/"
                    className="text-gray-200 fw-normal text-15 hover-text-main-600"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Add Course</span>
                </li>
              </ul>
            </div>
            {/* Breadcrumb End */}
            {/* Buttons Start */}
            <div className="flex-align justify-content-end gap-8">
              {/* <button
                type="button"
                className="btn btn-outline-main bg-main-100 border-main-100 text-main-600 rounded-pill py-9"
                disabled={loading}
              >
                Save as Draft
              </button> */}
              {/* <button
                type="submit"
                form="addCourseForm"
                className="btn btn-main rounded-pill py-9"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit Course'}
              </button> */}
            </div>
            {/* Buttons End */}
          </div>
          {/* Create Course Step List Start */}
          <ul className="step-list mb-24">
            <li className="step-list__item py-15 px-24 text-15 text-heading fw-medium flex-center gap-6 active">
              <span className="icon text-xl d-flex">
                <i className="" />
              </span>
              <h3>Course Details</h3>
              <span className="line position-relative" />
            </li>
          </ul>
          {/* Create Course Step List End */}
          {/* Course Form Tab Start */}
          <div className="card">
            <div className="card-header border-bottom border-gray-100 flex-align gap-8">
              <h5 className="mb-0">Add New Course</h5>
              <button
                type="button"
                className="text-main-600 text-md d-flex"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-title="Add Course Details"
              >
                <i className="ph-fill ph-question" />
              </button>
            </div>
            <div className="card-body">
              {message && (
                <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} mb-20`} role="alert">
                  {message}
                </div>
              )}
              <form id="addCourseForm" onSubmit={handleSubmit}>
                <div className="row gy-20">
                  {/* Course Information */}
                  <div className="col-xxl-12">
                    <h6 className="mb-20 fw-semibold font-heading">
                      Course Information
                    </h6>
                    <div className="row g-20">
                      <div className="col-sm-6">
                        <label
                          htmlFor="courseName"
                          className="h5 mb-8 fw-semibold font-heading"
                        >
                          Course Name{" "}
                          <span className="text-13 text-red-500 fw-medium">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control py-11"
                          id="courseName"
                          placeholder="Enter Course Name"
                          value={formData.courseName}
                          onChange={handleInputChange}
                          required
                          disabled={loading}
                        />
                        {errors.courseName && (
                          <div className="text-danger mt-2">{errors.courseName}</div>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label
                          htmlFor="courseImage"
                          className="h5 mb-8 fw-semibold font-heading"
                        >
                          Course Image{" "}
                          <span className="text-13 text-red-500 fw-medium">*</span>
                        </label>
                        <input
                          type="file"
                          className="form-control py-11"
                          id="courseImage"
                          accept="image/*"
                          onChange={handleImageChange}
                          required
                          disabled={loading}
                        />
                        {errors.courseImage && (
                          <div className="text-danger mt-2">{errors.courseImage}</div>
                        )}
                      </div>
                      <div className="col-sm-12">
                        <label
                          htmlFor="courseSummary"
                          className="h5 mb-8 fw-semibold font-heading"
                        >
                          Course Summary{" "}
                          <span className="text-13 text-red-500 fw-medium">*</span>
                        </label>
                        <textarea
                          className="form-control py-11"
                          id="courseSummary"
                          placeholder="Enter Course Summary"
                          rows="5"
                          value={formData.courseSummary}
                          onChange={handleInputChange}
                          required
                          disabled={loading}
                        ></textarea>
                        {errors.courseSummary && (
                          <div className="text-danger mt-2">{errors.courseSummary}</div>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label
                          htmlFor="coursePeriod"
                          className="h5 mb-8 fw-semibold font-heading"
                        >
                          Course Period{" "}
                          <span className="text-13 text-red-500 fw-medium">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control py-11"
                          id="coursePeriod"
                          placeholder="Enter Course Period (e.g., 6 months)"
                          value={formData.coursePeriod}
                          onChange={handleInputChange}
                          required
                          disabled={loading}
                        />
                        {errors.coursePeriod && (
                          <div className="text-danger mt-2">{errors.coursePeriod}</div>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label
                          htmlFor="fees"
                          className="h5 mb-8 fw-semibold font-heading"
                        >
                          Fees{" "}
                          <span className="text-13 text-red-500 fw-medium">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control py-11"
                          id="fees"
                          placeholder="Enter Course Fees"
                          value={formData.fees}
                          onChange={handleInputChange}
                          required
                          disabled={loading}
                        />
                        {errors.fees && (
                          <div className="text-danger mt-2">{errors.fees}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex-align justify-content-end gap-8">
                    <Link
                      to="/admin-dashboard"
                      className="btn btn-outline-main rounded-pill py-9"
                    >
                      Cancel
                    </Link>
                    <button
                      type="submit"
                      className="btn btn-main rounded-pill py-9"
                      disabled={loading}
                    >
                      {loading ? 'Submitting...' : 'Submit Course'}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/* Course Form Tab End */}
        </div>
        {/* footer */}
        <Footer />
      </div>
    </>
  );
}
export default AdminAddCourse;